import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "src/store";

import GroupSelectors from "@dashboard/groups/store/selectors";
import { Box, Typography } from "@mui/material";
import { Tooltip } from "@shared/Tooltip";

import { useStyles } from "./AddDeviceModal.styles";

export type AddedDeviceType = {
    androidSerial: string;
    productName: string;
    groupId: number;
    error: string | null;
    createdAt: string;
};

export const AddedDevice = (props: AddedDeviceType) => {
    const { classes, cx } = useStyles();
    const { t } = useTranslation(["modals", "common"]);
    const group = useSelector((state) => GroupSelectors.selectGroupById(state, props.groupId));

    if (!group) {
        return null;
    }

    return (
        <Tooltip title={props.error} placement="right" disableChildrenWrapper>
            <Box className={classes.addedDeviceContainer}>
                <Box>
                    <Box className={classes.addedDeviceRow}>
                        <Typography variant="caption" className={classes.addedDeviceLabel}>
                            {t("common:label.product")}:
                        </Typography>
                        <Typography variant="body2">{props.productName}</Typography>
                    </Box>
                    <Box className={classes.addedDeviceRow}>
                        <Typography variant="caption" className={classes.addedDeviceLabel}>
                            {t("common:label.group")}:
                        </Typography>
                        <Typography variant="body2">{group.name}</Typography>
                    </Box>
                    <Box className={classes.addedDeviceRow}>
                        <Typography variant="caption" className={classes.addedDeviceLabel}>
                            {t("modals:addDevice.serialNumber")}:
                        </Typography>
                        <Typography variant="body2">{props.androidSerial}</Typography>
                    </Box>
                </Box>

                <Box className={classes.addedDeviceIconContainer}>
                    {props.error ? (
                        <i className={cx("fa-solid fa-circle-xmark fa-2xl", classes.addedDeviceIconError as string)} />
                    ) : (
                        <i className={cx("fa-solid fa-circle-check fa-2xl", classes.addedDeviceIconSuccess as string)} />
                    )}
                </Box>
            </Box>
        </Tooltip>
    );
};
